import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormLabel from '../controls/forms/FormLabel';

export interface IDeleteConfirmDialogProps<T> {
    delete: (item: T) => void;
    item: T;
    updateText: (text: string) => void;
    dialogName: string;
    title: string;
    promptText: string;
    errorMessage?: string;
    onCloseDialog?: () => void;
}

type IDeleteConfirmDialogPageProps<U> = IDeleteConfirmDialogProps<U>;

class DeleteConfirmDialog<V> extends React.Component<IDeleteConfirmDialogPageProps<V>> {
    constructor(props: IDeleteConfirmDialogPageProps<V>) {
        super(props);
    }

    updateDeleteString = (e: React.ChangeEvent<HTMLInputElement>) => {
        const deleteText = e.currentTarget.value;
        this.props.updateText(deleteText);
    };

    public render() {
        return (
            <Dialog dialogName={this.props.dialogName} title={this.props.title} onCloseDialog={this.props.onCloseDialog}>
                <div style={{ maxWidth: '40rem', maxHeight: '50rem', overflow: 'auto' }}>
                    <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>

                    <Form
                        onSubmit={() => {
                            return;
                        }}
                    >
                        <div style={{ marginTop: '1.5rem' }}>
                            <FormLabel text={this.props.promptText} />
                        </div>
                        <div style={{ marginTop: '1.5rem' }}>
                            <FormTextBox name="searchString" onChange={this.updateDeleteString} />
                        </div>
                    </Form>
                    <div className="mt-2">
                        <Button text="DELETE" intent="danger" onClick={() => this.props.delete(this.props.item)} />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default DeleteConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/admin/DeleteConfirmDialog.tsx